import {createAsyncThunk, createSlice, isAnyOf} from '@reduxjs/toolkit';
import {ICareerState} from "../../../../interface/Passport/Career/frontend";
import {IErrorResult, IServerError} from "../../../../interface/Basic/api";
import {deleteCareer, getCareers, getPlacesOfWork, getPosts, saveCareer} from "./api";
import {ICareerResponse, ISaveCareerRequest} from "../../../../interface/Passport/Career/backend";
import {
    InputOption,
    IOption,
    IOptionsResponse
} from "../../../../interface/Passport/Education/backend";

export const GetCareers = createAsyncThunk<ICareerResponse, undefined, { rejectValue: IErrorResult }>
('getCareers', (data, thunkAPI) => getCareers()
    .then(resolve => resolve)
    .catch((error: IServerError) => {
        return thunkAPI.rejectWithValue(error.response.data.error);
    }))

export const SaveCareer = createAsyncThunk<undefined, ISaveCareerRequest, { rejectValue: IErrorResult }>
('saveCareer', (data, thunkAPI) => saveCareer(data)
    .then(resolve => resolve)
    .catch((error: IServerError) => {
        return thunkAPI.rejectWithValue(error.response.data.error);
    }))

export const DeleteCareer = createAsyncThunk<undefined, number, { rejectValue: IErrorResult }>
('deleteCareer', (data, thunkAPI) => deleteCareer(data)
    .then(resolve => resolve)
    .catch((error: IServerError) => {
        return thunkAPI.rejectWithValue(error.response.data.error);
    }))

export const GetPlacesOfWork = createAsyncThunk<IOptionsResponse, undefined, { rejectValue: IErrorResult }>
('getPlacesOfWork', (data, thunkAPI) => getPlacesOfWork()
    .then(resolve => resolve)
    .catch((error: IServerError) => {
        return thunkAPI.rejectWithValue(error.response.data.error);
    }))


export const GetPosts = createAsyncThunk<IOptionsResponse, undefined, { rejectValue: IErrorResult }>
('getPosts', (data, thunkAPI) => getPosts()
    .then(resolve => resolve)
    .catch((error: IServerError) => {
        return thunkAPI.rejectWithValue(error.response.data.error);
    }))

export const slice = createSlice({
    name: 'career',
    initialState: {
        careers: [
            {
                "id": 1,
                "city": {
                    "id": 1,
                    "name": "Москва",
                    "country": {
                        "id": 1,
                        "name": "Россия"
                    }
                },
                "place_of_work": {
                    "id": 3,
                    "name": "Школа английского языка"
                },
                "post": null,
                "start_year": null,
                "end_year": null
            }, {
                "id": 2,
                "city": {
                    "id": 1,
                    "name": "Москва",
                    "country": {
                        "id": 1,
                        "name": "Россия"
                    }
                },
                "place_of_work": {
                    "id": 3,
                    "name": "Школа английского языка"
                },
                "post": {
                    "id": 9,
                    "name": "Учитель"
                },
                "start_year": "2004",
                "end_year": null
            }
        ],
        countries: [],
        cities: [],
        places_of_work: [],
        posts: [],
        is_success: false,
        error: {},
    } as ICareerState,

    reducers:
        {},
    extraReducers: (builder) => {
        builder.addCase(GetPlacesOfWork.fulfilled, (state, action) => {
            const data = action.payload.data
            state.places_of_work = data.map((item: IOption) => InputOption.parse(item));
        })

        builder.addCase(GetPosts.fulfilled, (state, action) => {
            const data = action.payload.data
            state.posts = data.map((item: IOption) => InputOption.parse(item));
        })

        builder.addMatcher(isAnyOf(
                SaveCareer.fulfilled,
                DeleteCareer.fulfilled),
            (state) => {
                state.is_success = true
            })

        builder.addMatcher(isAnyOf(
                SaveCareer.pending,
                SaveCareer.rejected,
                DeleteCareer.pending,
                DeleteCareer.rejected),
            (state) => {
                state.is_success = false
            })
    }
})

export const {
} = slice.actions;

export default slice.reducer;